import type { SessionResponse } from "@kundeninfo/api-client";
import { ANWENDUNGSNAME } from "./umgebung.js";

/*
 * Der ZUSCHNITT der Oberfläche (Spec „Belegdesign als eigenständige ME-Anwendung“,
 * Entscheid 46 vom 08.10.2026). Der Dienst leitet ihn aus dem Hostnamen ab
 * (`zuschnitte` in kundeninfo.config.json) und meldet ihn mit der Sitzung; unter
 * belegdesign.meine-energie.de zeigt dieselbe Anwendung dann nur den Belegdesigner.
 *
 * Der Zuschnitt ist Kosmetik, kein Sicherheitsmerkmal. Er versteckt Navigation; er
 * vergibt und entzieht keine Rechte — die Routen prüfen unverändert `nurAdmin` bzw.
 * `requireUser` auf dem Server. Wer eine andere Adresse eintippt, sieht weiter, was
 * seine Rolle hergibt.
 *
 * Wegwerfware bis zum Umzug ins Portal (Entscheid 1c) — bewusst klein gehalten.
 */
export type Zuschnitt = "belegdesign" | "voll";

/** Der Zuschnitt aus der Sitzungsantwort; ein älterer Dienst ohne das Feld heisst „voll". */
export function zuschnittAusSitzung(antwort: SessionResponse): Zuschnitt {
  return antwort.zuschnitt === "belegdesign" ? "belegdesign" : "voll";
}

/**
 * Der WIRKSAME Zuschnitt: Den Belegdesigner gibt es nur für Administratoren (der Server
 * weist die Layout-Routen allen anderen ab). Ein Nicht-Administrator unter dem
 * Belegdesign-Namen bekäme sonst eine leere Navigation und einen Einstieg, der ihn sofort
 * wieder hinauswirft — er sieht deshalb die volle Anwendung.
 */
export function wirksamerZuschnitt(zuschnitt: Zuschnitt, istAdmin: boolean): Zuschnitt {
  return istAdmin ? zuschnitt : "voll";
}

/** Der Name der Anwendung in Reiter, Namenszug und Wortmarke. */
export function anwendungsname(zuschnitt: Zuschnitt): string {
  return zuschnitt === "belegdesign" ? "Belegdesign" : ANWENDUNGSNAME;
}

/** Die Verwaltungsbereiche, die im Zuschnitt sichtbar bleiben (Ruling: Layout und
 *  Unternehmen — Akzentfarbe und Logo eines Layouts werden am Unternehmen gepflegt). */
export const BELEGDESIGN_VERWALTUNG = ["unternehmen", "layout", "nummerierung"] as const;
